var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Format from "string-format";
export const request = (options) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const url = `/api/v1/&/${options.path}`;
        const data = JSON.stringify(options.payload);
        xhr.open(options.method, url, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.setRequestHeader("Authorization", `Bearer ${options.authToken}`);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                const result = xhr.response ? JSON.parse(xhr.response) : {};
                if (xhr.status === 200 || xhr.status === 201) {
                    resolve(result);
                }
                else {
                    reject(result);
                }
            }
        };
        xhr.send(data);
    });
});
export const getToken = () => {
    const isPortalPage = window.location.pathname.startsWith("/portal");
    const isSubscriptionPage = window.location.pathname.startsWith("/subscription");
    if (isPortalPage === false && isSubscriptionPage === false) {
        return undefined;
    }
    return window.location.pathname.split("/").pop();
};
export class Loader {
    static show() {
        var _a;
        (_a = document.querySelector(this.selector)) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
    }
    static hide() {
        var _a;
        (_a = document.querySelector(this.selector)) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
    }
}
Loader.selector = ".loader-wrap";
export const translate = (translationKey, args) => {
    if (languageResource == null) {
        return translationKey;
    }
    const translation = languageResource[translationKey] || translationKey;
    return Format(translation, args);
};
export const setPageError = (msg = translate("messages__default")) => {
    const element = document.getElementById("page-error");
    if (element != null) {
        element.innerText = msg;
        element.classList.remove("visually-hidden");
    }
};
